import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import TemplateSelectorTreeComponent from '@/components/template/TemplateSelectorComponent/TemplateSelectorTreeComponent.vue'
import CustomDialogHeaderComponent from '@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'
import type { ITemplate } from '@/store/modules/template/templateTypes'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateSelectorComponent',
  props: {
  showDialog: {
    type: Boolean,
    required: true
  },
  idEntityType: {
    type: [Number, String],
    required: true
  }
},
  emits: ['closeTemplateDialog', 'generateTemplateDialog'],
  setup(__props, { emit }) {

const props = __props;

// IMPORTS ==========================================================
const { t } = useI18n()

// DEFINE PROPS ==========================================================


// EVENTS ==========================================================


// DATA ==========================================================
const generatingTemplate = ref(false)
const templateSelected = ref<ITemplate | null>(null)
const componentKey = ref(0)
const treeLoading = ref(false)

const texts = {
  title: t('components.file_manager.dialogs.select_template').toString(),
  cancel: t('action_buttons.cancel').toString(),
  generate: t('action_buttons.generate').toString()
}

// COMPUTED ==========================================================
const hasSelectedTemplate = computed(() => {
  return templateSelected.value !== null
})

// METHODS ==========================================================
const updateComponent = async () => {
  componentKey.value += 1
  return componentKey.value
}

const getTemplateSelected = (template: ITemplate) => {
  templateSelected.value = template
}

const close = () => {
  templateSelected.value = null
  emit('closeTemplateDialog')
}

const generate = () => {
  emit('generateTemplateDialog', templateSelected.value)
  templateSelected.value = null
  generatingTemplate.value = true
  treeLoading.value = true
  updateComponent().then(() => {
    treeLoading.value = false
    generatingTemplate.value = false
  })
}

return { __sfc: true,t, props, emit, generatingTemplate, templateSelected, componentKey, treeLoading, texts, hasSelectedTemplate, updateComponent, getTemplateSelected, close, generate, TemplateSelectorTreeComponent, CustomDialogHeaderComponent }
}

})